export function formatCurrency(amount, currency = 'ILS') {
    return new Intl.NumberFormat('he-IL', {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(amount);
}
export function formatDate(date, locale = 'he-IL') {
    const d = typeof date === 'string' ? new Date(date) : date;
    return new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    }).format(d);
}
/**
 * Format a 24h "HH:MM" time string as 12h AM/PM ("13:30" → "1:30PM") —
 * the same display used across timeline views. Non-standard values are
 * returned as-is; null/undefined become an empty string.
 */
export function formatTimeDisplay(time) {
    if (!time)
        return '';
    const match = time.match(/^(\d{1,2}):(\d{2})$/);
    if (match) {
        const h = parseInt(match[1]);
        const m = match[2];
        return `${h % 12 || 12}:${m}${h >= 12 ? 'PM' : 'AM'}`;
    }
    return time;
}
/**
 * Build a WhatsApp chat link (wa.me) from a free-form phone number.
 * Strips formatting; a 10-digit number is assumed to be US/CA (+1).
 * Returns null when the number is missing or too short to be dialable.
 */
export function buildWhatsAppUrl(phone) {
    if (!phone)
        return null;
    const digits = phone.replace(/\D/g, '');
    if (digits.length < 8)
        return null;
    const withCountry = digits.length === 10 ? `1${digits}` : digits;
    return `https://wa.me/${withCountry}`;
}
export function formatDateShort(date, locale = 'he-IL') {
    const d = typeof date === 'string' ? new Date(date) : date;
    return new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(d);
}
//# sourceMappingURL=formatters.js.map